import axios from 'axios';
export default axios.create({
    baseURL: 'https://myfinancesrizqi.herokuapp.com/' // Production
    // baseURL: 'http://localhost:3000' // Development
})